export const ARTICLES_LOADED_SUCCESS = 'ARTICLES_LOADED_SUCCESS';
export const ARTICLES_LOADED_FAILURE = 'ARTICLES_LOADED_FAILURE';
export const UNREAD_COUNT_SUCCESS = 'UNREAD_COUNT_SUCCESS';
export const UNREAD_COUNT_FAILURE = 'UNREAD_COUNT_FAILURE';
export const ARCHIVED_COUNT_SUCCESS = 'ARCHIVED_COUNT_SUCCESS';
export const ARCHIVED_COUNT_FAILURE = 'ARCHIVED_COUNT_FAILURE';
export const SINGLE_ARTICLE_LOADED = 'SINGLE_ARTICLE_LOADED';
export const DECREMENT_READ_COUNT = 'DECREMENT_READ_COUNT';
export const DISPLAY_TYPE_CHANGED = 'DISPLAY_TYPE_CHANGED';
export const VIEW_PREFERENCE_LOADED_SUCCESS = 'VIEW_PREFERENCE_LOADED_SUCCESS';
export const VIEW_PREFERENCE_LOADED_FAILED = 'VIEW_PREFERENCE_LOADED_FAILED';
export const VIEW_PREFERENCE_SAVED_SUCCESS = 'VIEW_PREFERENCE_SAVED_SUCCESS';
export const VIEW_PREFERENCE_SAVED_FAILURE = 'VIEW_PREFERENCE_SAVED_FAILURE';
export const EDUCATION_ARTICLE_REQUESTED = 'EDUCATION_ARTICLE_REQUESTED';
export const EDUCATION_ARTICLE_REQUESTED_FAIL = 'EDUCATION_ARTICLE_REQUESTED_FAIL';
export const EDUCATION_ARTICLE_SELECTED = 'EDUCATION_ARTICLE_SELECTED';
